import styled from 'styled-components';

export const InputWithUnit = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;

  input {
    flex: 1;
    min-width: 0;
    height: 30px;
    padding: 0 0.5rem;
    border: 1px solid #ddd;
    border-radius: 7px 0 0 7px;
    border-right: none;
    font-size: 0.8rem;
    box-sizing: border-box;
    
    &:focus {
      outline: none;
      border-color: #4AE66E;
    }
  }
`;

export const UnitSwitcher = styled.div`
  display: flex;
  flex-wrap: nowrap;
  height: 30px;
  border-right: none;
  overflow: hidden;
  min-width: fit-content;
`;

export const UnitOption = styled.button`
  padding: 0 0.5rem;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  background: ${props => props.selected ? '#f5f5f5' : 'transparent'};
  color: ${props => props.selected ? '#1e1e1e' : '#999'};
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.1s ease;
  white-space: nowrap;
  font-weight: ${props => props.selected ? '500' : '400'};
  min-width: fit-content;

  &:hover {
    background: ${props => props.selected ? '#f5f5f5' : 'transparent'};
  }

  &:last-child {
    border-right: 1px solid #ddd;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
`; 